<section class="page-not-found" fxLayout="column" fxLayoutAlign="center">
  <img src="assets/images/error-placeholder.svg" width="200" height="200" class="centered mb-7" [alt]="'page-not-found.title' | translate">
  <h1 class="page-not-found__title text-danger text-bold">{{'page-not-found.title' | translate}}</h1>
  <p class="page-not-found__message text-hint" [innerHtml]="'page-not-found.message'| translate"></p>
</section>
